/**
 * Utilidades para resolver el tipo mime de un archivo antes de enviarlo a GESTORAPI.
 *
 * El navegador no reporta un tipo mime confiable para todas las extensiones: para los
 * correos .eml que entrega la DIAN, Chrome devuelve "" o "application/octet-stream"
 * cuando el sistema operativo no tiene un cliente de correo asociado. GESTORAPI valida
 * TYPEXXXX contra una lista blanca, por lo que el tipo se debe normalizar aqui.
 */

export const EML_TYPE = "message/rfc822";

//Tipos que el navegador entrega cuando no reconoce la extension del archivo
const UNKNOWN_TYPES = ["", "application/octet-stream", "binary/octet-stream"];

//Tipos que se resuelven por extension cuando el navegador no los reconoce
const TYPES_BY_EXTENSION = {
  eml: EML_TYPE,
};

/**
 * Devuelve la extension en minusculas de un nombre de archivo
 * @param {string} fileName nombre del archivo con extension
 * @returns {string} extension sin punto, cadena vacia si no tiene
 */
export const getExtension = (fileName) => {
  const name = String(fileName || "");
  if (!name.includes(".")) {
    return "";
  }
  return name.split(".").pop().toLowerCase();
};

/**
 * Resuelve el tipo mime que se debe enviar en TYPEXXXX
 * @param {File} file archivo seleccionado por el usuario
 * @returns {string} tipo mime normalizado
 */
export const resolveContentType = (file) => {
  const browserType = String(file?.type || "").toLowerCase();
  const byExtension = TYPES_BY_EXTENSION[getExtension(file?.name)];
  //Prefiero la extension solo cuando el navegador no supo identificar el archivo
  if (byExtension && UNKNOWN_TYPES.includes(browserType)) {
    return byExtension;
  }
  return browserType;
};

/**
 * Indica si un tipo mime corresponde a un correo electronico
 * @param {string} contentType tipo mime a evaluar
 * @returns {boolean} verdadero cuando es un correo RFC 822
 */
export const isEmlType = (contentType) => String(contentType || "").toLowerCase() === EML_TYPE;
